const DRIVE_PREFIX = 'drive://';

/**
 * A saved note, as the values the form edits (CT-5528).
 *
 * The note's links are one list of two kinds; the form keeps them apart —
 * documents from the drive (carried as `{ drive_file_id }`) and plain URLs.
 */
export const noteToFormValues = (note) => ({
  title: note.title,
  body: note.body,
  scope: note.scope,
  files: note.links
    .filter((link) => link.kind === 'document')
    .map((link) => ({ id: link.url.startsWith(DRIVE_PREFIX) ? link.url.slice(DRIVE_PREFIX.length) : link.url, name: link.label })),
  urls: note.links.filter((link) => link.kind !== 'document').map((link) => link.url),
});
